import { makeStyles } from '@material-ui/core';
import MKRailLogo from './logo.png';

const useStyles = makeStyles({
  logo: {
    height: 45,
    width: 'auto',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  // Apply the className to the img tag
  return <img src={MKRailLogo} className={classes.logo} alt="Company Logo" />;
};

export default LogoFull;